exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".aspect-ratio-box {\n    background-position-y: center;\n}\n\n.aspect-ratio-box:hover {\n    -webkit-filter: grayscale(100%);\n            filter: grayscale(100%);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /tmp/build_fdb7fa8d/src/app/products/products.component.css
// module id = ../../../../../src/app/products/products.component.css
// module chunks = main